import React from "react";

import { Placeholder, Segment } from "semantic-ui-react";

function ProcessFieldPlaceholder() {
  return (
    <Segment size="small" style={{ margin: "0 0 0.5em 0" }}>
      <Placeholder fluid data-test="processes-field-placeholder">
        <Placeholder.Header>
          <Placeholder.Line length="full" />
        </Placeholder.Header>
      </Placeholder>
    </Segment>
  );
}

export default ProcessFieldPlaceholder;
